import { IVehicleModel } from '../../interfaces';
import destructureAxiosReq from '../../services/destructureAxiosReq';
import sureAxios from '../../services/sureAxios';

export default {
  getVehiclesYears(region_code: string, effective_date?: string) {
    const version = region_code === 'SC' ? 1 : 2;
    return destructureAxiosReq<number[]>(
      sureAxios.get(`/api/vehicles/v${version}/years`, {
        params: {
          region_code,
          effective_date,
        },
      })
    );
  },

  getVehiclesMakes(
    year: string | number,
    region_code: string,
    effective_date?: string
  ) {
    const version = region_code === 'SC' ? 1 : 2;
    return destructureAxiosReq<string[]>(
      sureAxios.get(`/api/vehicles/v${version}/makes`, {
        params: {
          year,
          region_code,
          effective_date,
        },
      })
    );
  },

  getVehiclesModels(
    year: string | number,
    make: string,
    region_code: string,
    effective_date?: string
  ) {
    const version = region_code === 'SC' ? 1 : 2;
    return destructureAxiosReq<IVehicleModel[]>(
      sureAxios.get(`/api/vehicles/v${version}/models`, {
        params: {
          year,
          make,
          region_code,
          effective_date,
        },
      })
    );
  },

  downloadDigitalId(
    policyId: string,
    {
      id_type,
      is_preview,
    }: { id_type: 'apple' | 'android'; is_preview: boolean }
  ) {
    return destructureAxiosReq<{ file?: string; link?: string }>(
      sureAxios.post(`/api/management/v1/policies/${policyId}/digital-id`, {
        id_type,
        is_preview,
      })
    );
  },
};
